<script setup>
import { computed, ref, watch } from 'vue'
import { logoAltText, logoInitials, normalizeSessionBranding, safeLogoUrl } from '../branding/sessionBranding.js'

const props = defineProps({
  branding: { type: Object, default: () => ({}) },
  variant: { type: String, default: 'default' },
  showName: { type: Boolean, default: false },
  allowBlob: { type: Boolean, default: false },
})

const failed = ref(false)
const normalized = computed(() => normalizeSessionBranding(props.branding))
const source = computed(() => safeLogoUrl(normalized.value.logoUrl, { allowBlob: props.allowBlob }))
const alt = computed(() => logoAltText(normalized.value))
const hasIdentity = computed(() => Boolean(source.value || normalized.value.clientName))
const showFallback = computed(() => !source.value || failed.value)

watch(source, () => { failed.value = false })
</script>

<template>
  <div v-if="hasIdentity" class="event-brand gather-logo" :class="`event-brand--${variant}`" :role="showFallback ? 'img' : undefined" :aria-label="showFallback ? alt : undefined">
    <img v-if="source && !failed" class="gather-logo__image" :src="source" :alt="alt" :width="normalized.width || undefined" :height="normalized.height || undefined" decoding="async" @error="failed = true" />
    <span v-else class="event-brand__fallback gather-logo__fallback" aria-hidden="true">{{ logoInitials(normalized.clientName) }}</span>
    <span v-if="showName && normalized.clientName" class="event-brand__name gather-logo__name" aria-hidden="true">{{ normalized.clientName }}</span>
  </div>
</template>
